/* Imports */

import { configureStore } from "@reduxjs/toolkit";

import apiSlice from "./slices/api.slice";
import groupsReducer from "./slices/groups.slice";
import breadcrumbReducer from "./slices/breadCrumb.slice";
import reportsReducer from "./slices/reports.slice";
import doorsReducer from "./slices/doors.slice";

/* Store initialization */

const store = configureStore({
  reducer: {
    breadcrumb: breadcrumbReducer,
    groups: groupsReducer,
    doors: doorsReducer,
    reports: reportsReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

/* Exports */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
